import { ContainerItemStore } from '@planning/rt-stores/container/ContainerItemStore'
import { OrderItemStore } from '@planning/rt-stores/order/OrderItemStore'
import { action, computed, makeObservable, observable } from 'mobx'

export class CheckoutContainerViewStore {
  orderId?: number | null

  isLoading = false

  constructor(
    private containerItemStore: ContainerItemStore,
    private orderItemStore: OrderItemStore,
  ) {
    makeObservable(this, {
      orderId: observable,
      isLoading: observable,

      order: computed,
      container: computed,

      setLoading: action,
      setOrderId: action,
    })
  }

  get order() {
    if (this.orderId) {
      return this.orderItemStore.elements[this.orderId]?.data
    }
  }

  get container() {
    if (this.order?.containerId) {
      return this.containerItemStore.elements[this.order.containerId]?.data
    }
  }

  setOrderId = (orderId: number | null) => (this.orderId = orderId)

  setLoading = (isLoading: boolean) => (this.isLoading = isLoading)
}
